// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as GraphqlTag from "graphql-tag";
import * as SpaceX$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/SpaceX.res.mjs";
import * as QueryHook2$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/QueryHook2.res.mjs";
import * as LocaleContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocaleContext.res.mjs";
import * as WordFlyersFragments$LiteracyplanetClientSxEntry from "./WordFlyersFragments.res.mjs";

var Raw = {};

var query = GraphqlTag.gql([
      "query WordFlyersJourneyQuery($yearLevel: LearningLevelEnum!, $locale: Locale!)  {\nfindStrandsByLevel(level: $yearLevel, locale: $locale)  {\n...WordFlyersMenuFragment   \n}\n\n}\n",
      ""
    ], WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersMenuFragment.query);

function parse(value) {
  var value$1 = value.findStrandsByLevel;
  return {
          findStrandsByLevel: value$1.map(function (value) {
                return WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersMenuFragment.verifyArgsAndParse("WordFlyersMenuFragment", value);
              })
        };
}

function serialize(value) {
  var value$1 = value.findStrandsByLevel;
  var findStrandsByLevel = value$1.map(function (value) {
        return WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersMenuFragment.serialize(value);
      });
  return {
          findStrandsByLevel: findStrandsByLevel
        };
}

function serializeVariables(inp) {
  var a = inp.yearLevel;
  var a$1 = inp.locale;
  return {
          yearLevel: a === "LEVEL_10" ? "LEVEL_10" : (
              a === "LEVEL_11" ? "LEVEL_11" : (
                  a === "LEVEL_12" ? "LEVEL_12" : (
                      a === "PRE" ? "PRE" : (
                          a === "LEVEL_0" ? "LEVEL_0" : (
                              a === "LEVEL_1" ? "LEVEL_1" : (
                                  a === "LEVEL_2" ? "LEVEL_2" : (
                                      a === "LEVEL_3" ? "LEVEL_3" : (
                                          a === "LEVEL_4" ? "LEVEL_4" : (
                                              a === "LEVEL_5" ? "LEVEL_5" : (
                                                  a === "LEVEL_6" ? "LEVEL_6" : (
                                                      a === "LEVEL_7" ? "LEVEL_7" : (
                                                          a === "LEVEL_8" ? "LEVEL_8" : (
                                                              a === "LEVEL_9" ? "LEVEL_9" : "UNKNOWN"
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            ),
          locale: a$1 === "en_BZ" ? "en_BZ" : (
              a$1 === "en_CA" ? "en_CA" : (
                  a$1 === "en_CB" ? "en_CB" : (
                      a$1 === "en_GB" ? "en_GB" : (
                          a$1 === "en_IE" ? "en_IE" : (
                              a$1 === "en_IN" ? "en_IN" : (
                                  a$1 === "en_JM" ? "en_JM" : (
                                      a$1 === "en_NZ" ? "en_NZ" : (
                                          a$1 === "en_PH" ? "en_PH" : (
                                              a$1 === "en_TT" ? "en_TT" : (
                                                  a$1 === "en_US" ? "en_US" : (
                                                      a$1 === "en_ZA" ? "en_ZA" : (
                                                          a$1 === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        };
}

function makeVariables(yearLevel, locale, param) {
  return {
          yearLevel: yearLevel,
          locale: locale
        };
}

var JourneyQuery_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

var include = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query,
      Raw: Raw,
      parse: parse,
      serialize: serialize,
      serializeVariables: serializeVariables
    });

var use = include.use;

var useFetch = include.useFetch;

var JourneyQuery = {
  JourneyQuery_inner: JourneyQuery_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useFetch: useFetch
};

var JQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw,
      use: use,
      useFetch: useFetch
    });

var Raw$1 = {};

var query$1 = GraphqlTag.gql([
      "query WordFlyersGateQuery($id: ID!, $locale: Locale!)  {\nfindMenuNodesByParentId(id: $id, locale: $locale)  {\n...WordFlyersMenuFragment   \n}\n\n}\n",
      ""
    ], WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersMenuFragment.query);

function parse$1(value) {
  var value$1 = value.findMenuNodesByParentId;
  return {
          findMenuNodesByParentId: value$1.map(function (value) {
                return WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersMenuFragment.verifyArgsAndParse("WordFlyersMenuFragment", value);
              })
        };
}

function serialize$1(value) {
  var value$1 = value.findMenuNodesByParentId;
  var findMenuNodesByParentId = value$1.map(function (value) {
        return WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersMenuFragment.serialize(value);
      });
  return {
          findMenuNodesByParentId: findMenuNodesByParentId
        };
}

function serializeVariables$1(inp) {
  var a = inp.locale;
  return {
          id: inp.id,
          locale: a === "en_BZ" ? "en_BZ" : (
              a === "en_CA" ? "en_CA" : (
                  a === "en_CB" ? "en_CB" : (
                      a === "en_GB" ? "en_GB" : (
                          a === "en_IE" ? "en_IE" : (
                              a === "en_IN" ? "en_IN" : (
                                  a === "en_JM" ? "en_JM" : (
                                      a === "en_NZ" ? "en_NZ" : (
                                          a === "en_PH" ? "en_PH" : (
                                              a === "en_TT" ? "en_TT" : (
                                                  a === "en_US" ? "en_US" : (
                                                      a === "en_ZA" ? "en_ZA" : (
                                                          a === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        };
}

function makeVariables$1(id, locale, param) {
  return {
          id: id,
          locale: locale
        };
}

var GateQuery_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

var include$1 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$1,
      Raw: Raw$1,
      parse: parse$1,
      serialize: serialize$1,
      serializeVariables: serializeVariables$1
    });

var use$1 = include$1.use;

var useFetch$1 = include$1.useFetch;

var GateQuery = {
  GateQuery_inner: GateQuery_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useFetch: useFetch$1
};

var GQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$1,
      use: use$1,
      useFetch: useFetch$1
    });

var Raw$2 = {};

var query$2 = GraphqlTag.gql([
      "query WordFlyersActivitiesQuery($id: ID!, $locale: Locale!)  {\nfindActivitiesByParentId(id: $id, locale: $locale)  {\n...WordFlyersActivityFragment   \n}\n\n}\n",
      ""
    ], WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersActivityFragment.query);

function parse$2(value) {
  var value$1 = value.findActivitiesByParentId;
  return {
          findActivitiesByParentId: value$1.map(function (value) {
                return WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersActivityFragment.verifyArgsAndParse("WordFlyersActivityFragment", value);
              })
        };
}

function serialize$2(value) {
  var value$1 = value.findActivitiesByParentId;
  var findActivitiesByParentId = value$1.map(function (value) {
        return WordFlyersFragments$LiteracyplanetClientSxEntry.WordFlyersActivityFragment.serialize(value);
      });
  return {
          findActivitiesByParentId: findActivitiesByParentId
        };
}

function serializeVariables$2(inp) {
  var a = inp.locale;
  return {
          id: inp.id,
          locale: a === "en_BZ" ? "en_BZ" : (
              a === "en_CA" ? "en_CA" : (
                  a === "en_CB" ? "en_CB" : (
                      a === "en_GB" ? "en_GB" : (
                          a === "en_IE" ? "en_IE" : (
                              a === "en_IN" ? "en_IN" : (
                                  a === "en_JM" ? "en_JM" : (
                                      a === "en_NZ" ? "en_NZ" : (
                                          a === "en_PH" ? "en_PH" : (
                                              a === "en_TT" ? "en_TT" : (
                                                  a === "en_US" ? "en_US" : (
                                                      a === "en_ZA" ? "en_ZA" : (
                                                          a === "en_ZW" ? "en_ZW" : "en_AU"
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            )
        };
}

function makeVariables$2(id, locale, param) {
  return {
          id: id,
          locale: locale
        };
}

var UnitActivitiesQuery_inner = {
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2
};

var include$2 = SpaceX$LiteracyplanetClientFlags.Query.Extend({
      query: query$2,
      Raw: Raw$2,
      parse: parse$2,
      serialize: serialize$2,
      serializeVariables: serializeVariables$2
    });

var use$2 = include$2.use;

var useFetch$2 = include$2.useFetch;

var UnitActivitiesQuery = {
  UnitActivitiesQuery_inner: UnitActivitiesQuery_inner,
  Raw: Raw$2,
  query: query$2,
  parse: parse$2,
  serialize: serialize$2,
  serializeVariables: serializeVariables$2,
  makeVariables: makeVariables$2,
  use: use$2,
  useFetch: useFetch$2
};

var UQ = QueryHook2$LiteracyplanetClientFlags.Make({
      Raw: Raw$2,
      use: use$2,
      useFetch: useFetch$2
    });

function useJourney() {
  var fetchJourney = Curry._1(JQ.useAsync, undefined);
  return async function (variables) {
    return Belt_Option.mapWithDefault(await Curry._1(fetchJourney, variables), [], (function (res) {
                  return res.findStrandsByLevel;
                }));
  };
}

function useGate() {
  var fetchGate = Curry._1(GQ.useAsync, undefined);
  return async function (variables) {
    return Belt_Option.mapWithDefault(await Curry._1(fetchGate, variables), [], (function (res) {
                  return res.findMenuNodesByParentId;
                }));
  };
}

function useUnit() {
  var fetchUnit = Curry._1(UQ.useAsync, undefined);
  return async function (unit_, variables) {
    return Belt_Option.mapWithDefault(await Curry._1(fetchUnit, variables), {
                unit: unit_,
                activities: []
              }, (function (res) {
                  return {
                          unit: unit_,
                          activities: res.findActivitiesByParentId
                        };
                }));
  };
}

function yearLevel(id) {
  switch (id) {
    case "10" :
        return "LEVEL_10";
    case "7" :
        return "LEVEL_7";
    case "8" :
        return "LEVEL_8";
    case "9" :
        return "LEVEL_9";
    default:
      throw {
            RE_EXN_ID: "Match_failure",
            _1: [
              "WordFlyersIndexQuery.res",
              73,
              2
            ],
            Error: new Error()
          };
  }
}

function gateId(id) {
  switch (id) {
    case "0" :
        return 0;
    case "2" :
        return 2;
    case "3" :
        return 3;
    default:
      return 1;
  }
}

function use$3(param) {
  var api = LocaleContext$LiteracyplanetClientFlags.use();
  var locale = api.locale;
  var journeyHook = useJourney();
  var gateHook = useGate();
  var unitHook = useUnit();
  return async function (journey, optionalGate) {
    var gate = Belt_Option.getWithDefault(optionalGate, "1");
    var gates = await journeyHook({
          yearLevel: yearLevel(journey),
          locale: locale
        });
    var match = Belt_Array.get(gates, gateId(gate));
    var gateUnits = match !== undefined ? await gateHook({
            id: match.id,
            locale: locale
          }) : [];
    var units = await Promise.all(Belt_Array.map(gateUnits, (function (unit_) {
                return unitHook(unit_, {
                            id: unit_.id,
                            locale: locale
                          });
              })));
    return {
            gate: gate,
            gates: gates,
            units: units
          };
  };
}

var WordFlyersMenuFragment;

var WordFlyersActivityFragment;

export {
  WordFlyersMenuFragment ,
  WordFlyersActivityFragment ,
  JourneyQuery ,
  JQ ,
  GateQuery ,
  GQ ,
  UnitActivitiesQuery ,
  UQ ,
  useJourney ,
  useGate ,
  useUnit ,
  yearLevel ,
  gateId ,
  use$3 as use,
}
/* query Not a pure module */
